import { FormBean } from "../datatypes";
import {replaceUsingActionMessage} from "./error-utils";

export function validatePhoneNumber(phoneNumber:string, formBean:FormBean){
    let err = "Please enter the valid {attribute.label}";
    let errCode = 'phone.invalidError';
    if(!phoneNumber) return null;
    if(phoneNumber && phoneNumber.length <10)
        return replaceUsingActionMessage(errCode, err, formBean);
    else return null;
}
export function validateEmail(email:string, formBean:FormBean){
    let err = 'Please enter the valid {attribute.label}';
    let errCode = 'email.invalidError';
    if(!email) return "";
    const isValid = email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
    return isValid ? null : replaceUsingActionMessage(errCode, err, formBean);
}
export function notEmpty(value:any, formBean:FormBean){
    let err = 'Please enter the {attribute.label}';
    let errCode = 'attribute.empty';
    if(typeof value === "number" && (value>=0 || value<=0)) return null;
    if(!value || (typeof value === "string" && value.length===0))
        return replaceUsingActionMessage(errCode, err, formBean);
    return null;
}

